import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const CLOSE_AUCTION = 'AUCTION :: CLOSE_AUCTION';

export type TCloseAuctionAction = IReduxAction<typeof CLOSE_AUCTION>;

export const closeAuction = actionGenerator<typeof CLOSE_AUCTION>(CLOSE_AUCTION);
